import { Contact } from '@eigtech/contacts-types'
import { getContactName, getContactRoleLabel } from '@eigtech/ui-shared-contacts'
import { Stack, Tag, Text, Wrap, WrapItem } from '@eigtech/ui-shared-dave'
import { FieldValues, ReactSelectField, ReactSelectFieldProps } from '@eigtech/ui-shared-forms'
import { GroupBase, SelectComponentsConfig, chakraComponents } from 'chakra-react-select'

export type ContactSelectFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  IsMulti extends boolean = false,
> = ReactSelectFieldProps<TFieldValues, Contact, IsMulti> & { contacts: Contact[] }

export function ContactSelectField<
  TFieldValues extends FieldValues = FieldValues,
  IsMulti extends boolean = false,
>({ contacts, ...props }: ContactSelectFieldProps<TFieldValues, IsMulti>) {
  const reactSelectProps: ReactSelectFieldProps<TFieldValues, Contact, IsMulti> = {
    components: selectComponents<IsMulti>(),
    getOptionLabel: (contact: Contact) => getContactName(contact),
    getOptionValue: (contact: Contact) => contact.contactId,
    options: contacts,
    ...props,
  }

  return <ReactSelectField {...reactSelectProps} />
}

const selectComponents = <IsMulti extends boolean = false>(): SelectComponentsConfig<
  Contact,
  IsMulti,
  GroupBase<Contact>
> => ({
  Option: ({ children, ...props }) => (
    <chakraComponents.Option {...props}>
      <Stack spacing="0.5">
        <Text as="span">{children}</Text>
        <Wrap>
          {props.data.roles.map((role) => (
            <WrapItem key={role}>
              <Tag>{getContactRoleLabel(role)}</Tag>
            </WrapItem>
          ))}
        </Wrap>
      </Stack>
    </chakraComponents.Option>
  ),
})
